/**
 * SilkTale 品牌 - Welfare 页面配置
 */
import { welfareCommonConfig } from './common'
import type { WelfarePageConfig } from './types'
import { theme as brandTheme } from '@/config/brands'

export const theme = {
  // 按钮背景色
  btnBg: '#FFF7ED',
  // 按钮文本颜色 (使用主色)
  btnText: brandTheme.primaryColor,
  // 金币颜色 (使用主色)
  coinsColor: brandTheme.primaryColor,
  // 金币数量渐变色
  coinsGradient: '#FD9540',
  // 通用渐变色（任务按钮、弹窗按钮）
  actionGradient: brandTheme.primaryGradient,
  // Check-in 按钮渐变色
  checkinBtnGradient: '#FD9540',
} as const

export const resources = {
  // 首页背景图
  homeBg: '/images/silktale/welfare-bg.webp',
  // 金币图标
  welfareGold: '/images/silktale/welfare-gold.png',
  // 宝箱图标
  welfareBox: '/images/silktale/welfare-box.png',
} as const

export const welfareConfig: WelfarePageConfig = {
  theme,
  resources,
  texts: welfareCommonConfig.texts,
}
